import { readItems } from "@directus/sdk";
import getClient from "./ApiClient";

export interface Language {
  id: string;
  code: string;
  name: string;
}

export async function getLanguages(): Promise<Language[]> {
  const clientInstance = await getClient();
  return clientInstance.request(
    readItems("languages", {
      fields: ["id", "code", "name"],
      sort: ["name"]
    })
  ) as Promise<Language[]>;
}
